import React from 'react';
import * as Sentry from '@sentry/react';

// `/pdfs/:category/:dataId/printable` is the page headless Chrome renders into a
// PDF. Error reporting stays on -- it is the page we most want exceptions from --
// but performance tracing does not: the server waits for `networkidle0`, and a
// tracing envelope leaving for ingest.sentry.io restarts that quiet window on a
// tenth of all renders. See smartforwarder/app#6313.
const isPrintableRoute = /^\/pdfs\/[^/]+\/[^/]+\/printable\/?$/.test(window.location.pathname);

Sentry.init({
  dsn: 'https://999aa1bb9bde479f8ca94ce6cac89744@o1152791.ingest.sentry.io/4505270746742784',
  enabled: NODE_ENV !== 'development',
  environment: NODE_ENV,
  integrations: isPrintableRoute
    ? []
    : [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation,
        }),
      ],
  // Capture 100% of the transactions in dev, reduce in production, none on the print page.
  tracesSampleRate: isPrintableRoute ? 0 : NODE_ENV === 'development' ? 1 : 0.1,
  ignoreErrors: [
    /ResizeObserver loop completed/,
    /ResizeObserver loop limit exceeded/,
    /ResizeObserver loop completed with undelivered notifications./,
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
});

window.addEventListener('error', e => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});
